import React, { useState, useEffect, useContext } from 'react'
import { connect } from 'react-redux'

import Button from '../../../shared/ui/Button'

import PreferredTrainerSelectionForm from './PreferredTrainerSelectionForm'

import { Box, Typography } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import { withStyles } from '@material-ui/core/styles'
import Avatar from '@material-ui/core/Avatar'

const styles = theme => ({
  root: {
  },
  trainerName: {
    fontSize: '.8rem',
    textAlign: 'center',
    padding: theme.spacing(.5)
  },
  large:{
    width: '100px',
    height: '100px'
  }
})

const PreferredTrainersFormView = ({ theme, classes, edit=false, trainers, formData, onFormDataChange }) => {
  const columns = [
    { key: 'profile_picture_url', label: 'Image', type: 'image'},
    { key: 'first_name', label: 'Trainer Name' },
  ]
  
  const [showEditForm, setShowEditForm] = useState(false)
  
  useEffect(() => {
    // Hide editing if edit property is set to false
    if (showEditForm)
      setShowEditForm(false)
  }, [edit])
  
  // Note: formData.prices is undefined/null, meaning we should get data
  // from initialData
  const data = formData.trainers || []
  
  return (  
    <Box display='flex' flexDirection='row' flexWrap="wrap" mt={1} mb={1}>
      { data.map((item, index) =>        
        <Box 
          width='33%' 
          display='flex' mt={1} mb={1} 
          flexDirection='column' 
          justifyContent='center' 
          alignItems='center' 
          style={{position:'relative'}}
          >
            <Avatar alt={item.first_name} src={item.profile_picture_url} className={classes.large} />
            <Typography variant='body2' className={classes.trainerName}>
              {item.first_name + ' '+ item.last_name}
            </Typography>

            { edit &&
              <Box style={{position:'absolute', top:'-8px', right:'8px'}}>
                <Button icon={DeleteIcon} color='secondary' 
                  onClick={() => {
                    // Delete this trainer.
                    onFormDataChange({
                      trainers: data.filter(t => t.uid != item.uid)
                    })            
                  }}
                />
              </Box>
            }
        </Box>
      )}

      { data.length < 3 &&
        <Box 
          width='25%' 
          display='flex' mt={1} mb={1} 
          flexDirection='column' 
          justifyContent='center' 
          alignItems='center' 
          style={{position:'relative'}}
          >
          <Avatar alt='Add Trainers' style={{cursor:'pointer'}} onClick={() => setShowEditForm(true)}>
            +
          </Avatar>
        </Box>
      }
      
      { showEditForm &&
        <PreferredTrainerSelectionForm
          classes={classes}
          theme={theme}
          selectedTrainers={data}
          initialData={{trainers: trainers}}
          onAddTrainer={(trainer) => {
            onFormDataChange({
              trainers: [
                ...data,
                trainer
                ]
            })
          }}
          onRemoveTrainer={(trainer) => {
            onFormDataChange({
              trainers: data.filter(t => t.uid != trainer.uid)
            })            
          }}
          onClose={() => setShowEditForm(false)}
        />
      }
      
      {/*
      <TableData columns={columnsTrainers} rows={data.trainers} getCellValue={getCellValue}/>
      */}
    </Box>
  )
}

const mapStateToProps = (state, ownProps) => {
  return {
    
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    
  }
}

export default withStyles(styles, { withTheme: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps
   )(PreferredTrainersFormView)
)
